import React from "react";
import PropTypes from "prop-types";

import strings from "../../resources/strings";

class TermsOfService extends React.Component {
    render() {
        let state = this.props.store.getState();

        if (
            state.questionSet &&
            state.questionSet.questionSet &&
            state.workflowSession &&
            (state.workflowSession.currentQuestionId === state.questionSet.questionSet.questions[0].questionID ||
                state.workflowSession.currentQuestionId === "")
        ) {
            return (
                <a className="w3-small w3-text-blue" href={state.questionSet.termsOfServiceUrl ? state.questionSet.termsOfServiceUrl : strings.getString("termsOfServiceURL")}
                        target="_blank" rel="noopener noreferrer">
                    {state.questionSet.termsOfServiceText ? state.questionSet.termsOfServiceText : strings.getString("termsOfService")}
                </a>
            );
        }

        return null;
    }
}

TermsOfService.contextTypes = {
    store: PropTypes.object
};

export default TermsOfService;
